import { useEffect } from 'react';

import { useFlag } from '@/hook';

import type { VBaseButtonProps } from './type';

export const useButton = ({
  disabled,
  loading,
  onClick,
}: VBaseButtonProps & {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}) => {
  const {
    value: isLoading,
    setFalse: setIsLoaded,
    setTrue: setIsLoading,
  } = useFlag(loading);
  const buttonDisabled = disabled || isLoading;
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = e => {
    if (buttonDisabled || typeof onClick !== 'function') return;

    const returnValue: any = onClick(e);
    const target = e.target as HTMLButtonElement;

    if (returnValue instanceof Promise) {
      target.disabled = true;
      setIsLoading();

      returnValue.finally(() => {
        target.disabled = disabled ?? false;
        setIsLoaded();
      });
    }
  };

  useEffect(() => {
    if (loading) setIsLoading();
    else setIsLoaded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return {
    buttonDisabled,
    isLoading,
    setIsLoading,
    setIsLoaded,

    handleClick,
  };
};
